import { AgAreaSeriesMarkerItemStylerParams } from "ag-charts-community";
import { ICellRendererParams } from "ag-grid-enterprise";

// This function was migrated from APPRETIO PY. Consider reviewing and refactoring in the future.Only used  for testing purposes.
export function getSizeCurveSparklineParams(params: ICellRendererParams) {
  const nodeData = params?.node?.aggData || params?.node?.data || {};
  const populationSize = nodeData.population_size;

  return {
    sparklineOptions: {
      type: "bar",
      xKey: "size_label",
      yKey: "avg_nis3_od_ean_share",
      fill: "lightblue",
      tooltip: {
        renderer: (params: AgAreaSeriesMarkerItemStylerParams) => {
          const { yValue, xValue } = params;
          return {
            title: `Size: ${xValue}`,
            content: `NIS3%: ${yValue.toFixed(2)}<br/>Population Size: ${populationSize}`
          };
        }
      }
    }
  };
}

export function getSizeCurveSparklineParamsSizeCurve(
  params: ICellRendererParams
) {
  const nodeData = params.node?.aggData || params.node?.data || {};
  const { stockout } = nodeData;
  function tooltipRenderer(params: AgAreaSeriesMarkerItemStylerParams) {
    const { xValue, yValue } = params;
    return `<span><strong>Size:</strong> ${xValue}<br></span>
            <div><strong>NIS3%:</strong> ${yValue.toFixed(2)}</div>`;
  }
  return {
    sparklineOptions: {
      type: "bar",
      xKey: "size_label",
      yKey: "nis3_od_ean_share",
      fill: stockout ? "red" : "lightblue",
      tooltip: {
        renderer: tooltipRenderer
      }
    }
  };
}
